<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'
    export default {
        data() {
            return {
                crudName: 'Unidades',
                newText: 'Cadastrar Unidade',
                table: 'branchesTable',
                columns: ['id', 'company_id', 'name', 'cnpj', 'adress', 'actions'],
                tableData: ['id', 'company_id', 'name', 'cnpj', 'adress'],
                options: {
                    filterByColumn: true,
                    debounce: 1000,
                    sortable: ['id', 'company_id', 'name', 'cnpj', 'adress'],
                    filterable: ['id', 'company_id', 'name', 'cnpj', 'adress'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': '#',
                        'name' : 'Nome',
                        'company_id': 'Empresa',
                        'cnpj' : 'CNPJ',
                        'adress': 'Endereço',
                        'actions' : 'Ações'
                    },
                    templates: {
                        company_id: function(h, row, index){
                            return row.company.fantasy_name
                        }
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = ['company'];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    }
                },
                endPoint: 'branches/',
                dataForm: {
                  title: {
                    add: 'Nova Unidade',
                    edit: 'Editar Unidade',
                    view: 'Visualizar Unidade',
                    icon: 'fa fa-pen'
                  },
                  button: {
                    back: '/branches'
                  },
                  url: {
                    model: 'branches'
                  },
                  messages: {
                    success: {
                      add: 'Unidade cadastrado com sucesso!',
                      edit: 'Unidade alterado com sucesso!'
                    }
                  },
                  fields: [
                    {
                      name: 'company_id',
                      model: 'company_id',
                      label: 'Empresa',
                      type: 'select',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|12|12",
                      offset: null,
                      list: [],
                      list_label: 'fantasy_name'
                    },
                    {
                      name: 'name',
                      model: 'name',
                      label: 'Nome',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|12|12",
                      offset: null
                    },
                    {
                      name: 'cnpj',
                      model: 'cnpj',
                      label: 'CNPJ',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      mask:"##.###.###/####-##",
                      placeholder: '',
                      class: '',
                      length: "12|6|6",
                      offset: null
                    },
                    {
                      name: 'email',
                      model: 'email',
                      label: 'E-mail',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|6",
                      offset: null
                    },
                    {
                      name: 'cep',
                      model: 'cep',
                      label: 'CEP',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|3",
                      mask:"##.###-###",
                      offset: null
                    },
                    {
                      name: 'adress',
                      model: 'adress',
                      label: 'Endereço',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|9",
                      offset: null
                    }
                  ]
                }
            }
        },
        methods: {
            query: function (query) {
                let columns = {
                    id: 'id',
                    name : 'name',
                    company_id: 'company[fantasy_name]',
                    cnpj: 'cnpj',
                    adress: 'adress',
                };
                let filters = '';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });

                return filters;
            },
            getCompanies: function(){
              const self = this;
              const api = self.$store.state.api + 'companies?paginated=false';
              self.$http.get(api)
                .then((response) => {
                    let found = self.dataForm.fields.find(x => x.name == 'company_id')
                    if(found){
                      found.list = response.data.data
                    }
                }).catch((error) => {
                    self.$message('Erro', error.response.data, 'error');
                });
            }
        },
        mounted(){
          const self = this;
          self.getCompanies();
        },
        components: {
            BaseCrud
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Branch/Crud.vue